import React from 'react';
import Icon from '../../../../Component/Layouts/App/Candidates/StudentApp/Icon';
import { Chips, GradientMark, PageHeader, SectionTitle, XpBadge } from '../../../../Component/Layouts/App/Candidates/StudentApp/StudentUi';
import { useStudent } from '../../../../Component/Layouts/App/Candidates/StudentApp/StudentContext';
import { clubs } from '../../../../Component/Layouts/App/Candidates/StudentApp/studentData';

const Club = () => {
  const { saved, markSaved } = useStudent();

  return (
    <>
      <PageHeader
        title="Jobs & Activities"
        right={<button type="button" className="sa-ib" aria-label="Search"><Icon name="search" /></button>}
      />
      <div className="sa-hero green">
        <div className="sa-b">Find Your People<br />Build Your Passion</div>
        <p>Join clubs, attend events,<br />make an impact.</p>
        <Icon name="users" className="float" />
      </div>
      <Chips group="clubs" options={['My Clubs', 'All Clubs', 'Events']} />
      <SectionTitle title="Your Clubs" action="See all" />
      {clubs.map((club) => {
        const going = Boolean(saved[club.id]);
        return (
          <div className="sa-card sa-item" key={club.id}>
            <GradientMark name={club.icon} from={club.from} to={club.to} />
            <div className="sa-sp">
              <div className="sa-b">{club.title}</div>
              <div className="sa-mut">Next Event: {club.event}</div>
              <div className="sa-mut">{club.members} members · <XpBadge amount={club.xp} signed={false} /></div>
            </div>
            <button
              type="button"
              className={`sa-btn${going ? ' ok' : ''}`}
              onClick={() => markSaved(club.id, 'RSVP confirmed')}
            >
              {going ? 'Going' : 'RSVP'}
            </button>
          </div>
        );
      })}
      <div className="sa-card sa-row sa-leader">
        <GradientMark name="trophy" from="#fbbf24" to="#f97316" />
        <div className="sa-sp">
          <div className="sa-b">Club Leaderboard</div>
          <div className="sa-mut">Top 3 this month</div>
        </div>
        <Icon name="next" />
      </div>
    </>
  );
};

export default Club;
